import request from '../utils/request';

export function getUserInfo (){
    return request({
        url: "/wxmanager/person/userinfo",
        method:'post',
    });
}
export function getUserHealthPlanInfo (){
    return request({
        url: "/wxmanager/plan/planManager",
        method:'post',
    });
}
export function getUserOrderList (){
    return request({
        url: "/wxmanager/person/findUserOrderState",
        method:'post',
    });
}
export function getUserOrderCard (){
    return request({
        url: "/wxmanager/person/findUserOrderCard",
        method:'post',
    });
}
export function addUserSummary (data){
    console.log(data);
    return request({
        url: "/wxmanager/plan/addUserSummary",
        method:'post',
        data,
    });
}
